import React from "react";
import App from './App';
import PrivacyPolicy from './PolicyPolicy';
import TermsAndConditions from './TermsAndConditions';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import RefundPolicy from "./RefundPolicy";
import About from "./About";
import ScrollToTop from "./components/ScrollToTop";

export default function AppRouter() {
  return (
    <Router>
      <ScrollToTop/>
        <Switch>
          <Route path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Route path="/terms-and-conditions">
            <TermsAndConditions />
          </Route>
          <Route path="/refund-policy">
            <RefundPolicy/>
          </Route>
          <Route path="/about">
            <About/>
          </Route>

          <Route path="/">
            <App />
          </Route>
        </Switch>
    </Router>
  );
}
